import { Checkbox, Dialog } from "@mui/material";
import React, { useEffect, useState } from "react";

const EmissionStatusFilter = (props: any) => {
  const {
    setOpenStatusFilter,
    setStatusFilter,
    handleFilter,
    statusFiltersOptions,
    setStatusFiltersOptions,
    directEmissionApproval,
  } = props;
  const [selectedFilters, setSelectedFilters] = useState(
    directEmissionApproval
      ? statusFiltersOptions.filter((each: any) => each[0] !== "Pending")
      : statusFiltersOptions
  );
  const [triggerSave, setTriggerSave] = useState(false);
  const handleCheckBox = (e: any, index: any) => {
    const updatedSelection = [...selectedFilters];
    updatedSelection[index][1] = e.target.checked;
    setSelectedFilters([...updatedSelection]);
  };
  const handleClearAll = () => {
    const updatedSelection = selectedFilters.map((each: any) => {
      return [each[0], false];
    });
    setSelectedFilters(updatedSelection);
  };
  const handleFilterAction = () => {
    const updatedFilters = [...selectedFilters];
    setStatusFiltersOptions(updatedFilters);
    setTriggerSave(true);
  };
  useEffect(() => {
    if (triggerSave) {
      handleFilter();
      setTriggerSave(false);
    }
  }, [statusFiltersOptions, triggerSave]);
  return (
    <div>
      <Dialog
        className={`pw-update-filter-dialog-container pw-filter-container`}
        open={true}
      >
        <div className="pw-dialog-container">
          <div className="flex justify-between items-center w-full">
            <div className="pw-filter-text">Filters</div>
            <div
              onClick={handleClearAll}
              className="cursor-pointer pw-clear-color"
            >
              Clear all
            </div>
          </div>
          <div className="flex flex-col justify-start items-start w-full mt-8 gap-y-3">
            {selectedFilters.map((each: any, index: any) => {
              return (
                <div className="flex justify-start items-center gap-x-1">
                  <div>
                    <Checkbox
                      onClick={(e) => handleCheckBox(e, index)}
                      checked={each[1]}
                    />
                  </div>
                  <div
                    className={`pw-status-option-btn font-bold pw-${each[0]?.toLowerCase()}-filter`}
                  >
                    {each[0]}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="flex pw-filter-buttons gap-x-3">
          <div
            onClick={() => setOpenStatusFilter(false)}
            className="pw-bunit-button-light pw-bunit-button-next text-neutral bg-white font-bold"
          >
            Cancel
          </div>
          <div
            onClick={handleFilterAction}
            className={`pw-bunit-button-primary  pw-bunit-button-save text-white
               ${"cursor-pointer bg-primary"}`}
          >
            Save
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default EmissionStatusFilter;
